import React from 'react';
import FigmaIcon from '../images/icons/Figma.svg';
import VercelIcon from '../images/icons/Vercel.svg';
import CursorIcon from '../images/icons/CursorWhite.svg';
import ClaudeIcon from '../images/icons/Claude.svg';
import PerplexityIcon from '../images/icons/Perplexity.svg';
import DovetailIcon from '../images/icons/Dovetail.svg';
import ChatGPTIcon from '../images/icons/ChatGPT.svg';
import PencilIcon from '../images/icons/Pencil.svg';
import LoveableIcon from '../images/icons/Loveable.svg';

const TOOLS = [
  { name: 'Figma', src: FigmaIcon },
  { name: 'Cursor', src: CursorIcon, darkBg: true },
  { name: 'Claude', src: ClaudeIcon },
  { name: 'Perplexity', src: PerplexityIcon },
  { name: 'Dovetail', src: DovetailIcon, darkBg: true },
  { name: 'ChatGPT', src: ChatGPTIcon, darkBg: true },
  { name: 'Vercel', src: VercelIcon, darkBg: true, wideLogo: true },
  { name: 'Pencil', src: PencilIcon, darkBg: true, wideLogo: true },
  { name: 'Loveable', src: LoveableIcon, darkBg: true, wideLogo: true },
];

function Tools() {
  const renderTool = (tool, index, suffix = '') => (
    <div
      key={`${tool.name}-${suffix || index}`}
      className={`tools-item${tool.darkBg ? ' tools-item--dark' : ''}${tool.wideLogo ? ' tools-item--wide' : ''}${tool.name === 'Pencil' ? ' tools-item--pencil' : ''}${tool.name === 'Perplexity' ? ' tools-item--perplexity' : ''}`}
      role="listitem"
    >
      <img
        src={tool.src}
        alt={tool.name}
        className="tools-icon"
        width={32}
        height={32}
        loading="lazy"
      />
    </div>
  );

  return (
    <section className="tools-section" aria-labelledby="tools-heading">
      <p id="tools-heading" className="tools-section-label">
        Tools
      </p>
      <div className="tools-row" role="list" aria-label="Tools and software">
        <div className="tools-marquee-track">
          {TOOLS.map((tool, i) => renderTool(tool, i, 'a'))}
          {TOOLS.map((tool, i) => renderTool(tool, i, 'b'))}
        </div>
      </div>
    </section>
  );
}

export default Tools;
